<div class="!p-0 border bg-surface rounded-md flex !overflow-hidden">
  <div class="!min-w-2" [class]="bgColor()">&nbsp;</div>
  <div class="p-2 flex flex-col w-full" [class]="scheduled() ? 'bg-surface-tertiary' : ' '">
    <span class="text-sm font-semibold uppercase" [class]="headTextColor()">{{
      headText()
    }}</span>
    <p class="text-sm">{{ title() }}</p>
    <span class="text-xs break-all"> {{ description() }}</span>
    <span class="text-xs break-all"> {{ description2() }}</span>
    <span class="text-xs break-all"> {{ description3() }}</span>
    <span class="text-xs break-all"> {{ description4() }}</span>
  </div>
  <!--span class="text-light">{{ scheduled() ? 'E' : '' }}</span-->
</div>
